module.exports = __webpack_public_path__ + "static/media/youtube.94e04c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/youtube.svg
// module id = 198
// module chunks = 0